import ko from "knockout";

export interface SessionService {
    isOAuthSessionExpired: ko.Observable<boolean>;
    isLoggedIn: ko.Observable<boolean>;
    isSessionValid: ko.Observable<boolean>;
}

export const sessionService: Readonly<SessionService> = Object.freeze({
    isOAuthSessionExpired: ko.observable(false),
    isLoggedIn: ko.observable(false),
    isSessionValid: ko.observable(false),
});
